module.exports = __webpack_public_path__ + "school/img/trainBg.13e9b8da.jpg";